/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

export const RADIANCE_LAYERS_COUNT = 10

export const UPGRADE_CONFIRMATION_SUBMIT = (
    <FormattedMessage
        id='building_upgrade_confirmation.submit'
        defaultMessage={'Модернизировать'}
    />
)

export const UPGRADE_CONFIRMATION_LEVEL = (
    <FormattedMessage
        id='building_upgrade_confirmation.level'
        defaultMessage={'уровень'}
    />
)

export const UPGRADE_CONFIRMATION_MESSAGE = (name, level, industrialResource) => (
    <FormattedMessage
        id='building_upgrade_confirmation.message'
        defaultMessage={'Модернизировать строение {name} до {level} за {industrialResource}?'}
        values={{
            name,
            level,
            industrialResource,
        }}
    />
)

export const UPGRADE_CONFIRMATION_COMMAND_CENTER_MESSAGE = (level, industrialResource) => (
    <FormattedMessage
        id='building_upgrade_confirmation.command_center_message'
        defaultMessage={'Модернизировать Командный центр до {level} за {industrialResource}?'}
        values={{
            level,
            industrialResource,
        }}
    />
)



// WEBPACK FOOTER //
// ./components/UpgradeConfirmationView/constants.jsx